import { render, staticRenderFns } from "./otherlist.vue?vue&type=template&id=73abb9cb&scoped=true"
import script from "./otherlist.vue?vue&type=script&lang=js"
export * from "./otherlist.vue?vue&type=script&lang=js"
import style0 from "./otherlist.vue?vue&type=style&index=0&id=73abb9cb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73abb9cb",
  null
  
)

export default component.exports